/*
  The Enricher - split hero + tap-to-play watch section.

  The hero video's src lives in data-src and is only attached above the mobile
  breakpoint. `display: none` alone would not reliably stop a phone downloading
  the file, and the whole point of the mobile layout is to avoid that.
*/
(function () {
  var DESKTOP = '(min-width: 750px)';

  function attachHeroVideo() {
    var videos = document.querySelectorAll('.enr-shero__video[data-src]');
    if (!videos.length) return;

    var isDesktop = window.matchMedia(DESKTOP).matches;

    videos.forEach(function (video) {
      if (isDesktop && !video.src) {
        video.src = video.getAttribute('data-src');
        video.muted = true;
        // Autoplay can still be refused (low power mode); the poster stays up.
        var attempt = video.play();
        if (attempt && attempt.catch) attempt.catch(function () {});
      } else if (!isDesktop && video.src) {
        video.pause();
        video.removeAttribute('src');
        video.load();
      }
    });
  }

  function initSoundToggles() {
    document.querySelectorAll('[data-shero-sound]').forEach(function (button) {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';

      button.addEventListener('click', function () {
        var hero = button.closest('.enr-shero');
        var video = hero && hero.querySelector('.enr-shero__video');
        if (!video) return;

        video.muted = !video.muted;
        button.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
        hero.classList.toggle('enr-shero--sound-on', !video.muted);

        if (!video.muted && video.paused) {
          var attempt = video.play();
          if (attempt && attempt.catch) attempt.catch(function () {});
        }
      });
    });
  }

  function initWatchSections() {
    document.querySelectorAll('[data-watch-frame]').forEach(function (frame) {
      if (frame.dataset.bound) return;
      frame.dataset.bound = 'true';

      var button = frame.querySelector('[data-watch-play]');
      var video = frame.querySelector('video[data-src]');
      if (!button || !video) return;

      button.addEventListener('click', function () {
        /*
          Attach the source and call play() inside the same gesture. iOS only
          honours playback started directly from a user gesture, so nothing
          async may come between the tap and the play() call.
        */
        if (!video.src) {
          video.src = video.getAttribute('data-src');
          video.load();
        }

        // Show a buffering state immediately; over mobile data the first frame
        // can be seconds away and silence reads as a broken button.
        frame.classList.add('is-loading');

        var attempt = video.play();
        if (attempt && attempt.catch) {
          attempt.catch(function () {
            // Autoplay refused or still buffering: fall back to native controls.
            frame.classList.remove('is-loading');
            frame.classList.remove('is-playing');
          });
        }
      });

      video.addEventListener('playing', function () {
        frame.classList.remove('is-loading');
        frame.classList.add('is-playing');
        // Hide outright rather than relying on the opacity rule, which lost.
        button.style.display = 'none';
      });

      video.addEventListener('waiting', function () {
        frame.classList.add('is-loading');
      });

      video.addEventListener('error', function () {
        frame.classList.remove('is-loading', 'is-playing');
      });

      video.addEventListener('pause', function () {
        if (video.currentTime === 0) {
          frame.classList.remove('is-playing');
          button.style.display = '';
        }
      });
    });
  }

  function init() {
    attachHeroVideo();
    initSoundToggles();
    initWatchSections();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-evaluate when crossing the breakpoint (rotation, resize, devtools).
  if (window.matchMedia) {
    var mq = window.matchMedia(DESKTOP);
    var onChange = function () { attachHeroVideo(); };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);
  }

  // Shopify theme editor re-renders sections without a full page load.
  document.addEventListener('shopify:section:load', init);
})();
